import React from "react"
import { Typography } from "@material-ui/core"

export const SectionTitle = (props) => (
  <Typography variant="h4" gutterBottom>
    {props.children}
  </Typography>
)
